import React from 'react';
import { GAMES_WITH_1X2, SPORTS } from 'constants/appConfig';
import { isMarketOverUnder } from 'utils/Helper';
import { detectMobile } from 'utils/UiHelper';
import { Row } from '../../styled';
import ViewMainMarketBtn from './ViewMainMarketBtn/ViewMainMarketBtn';
import ViewOUButtons from './ViewOddsButtons/ViewOddsButtons';
import {
    MarketButtonsCol,
    MarketButtonsRow,
    OUMarketButtonsCol,
} from './styled';
import { useContainerWidth } from '../../contexts/ContainerWidthContext';

const MainMarkets = ({ market, ev, disabled, live }) => {
    const items = market && market.itemList ? market.itemList : [];
    const isFootball = ev.sportId === SPORTS.FOOTBALL;
    const contentWidth = useContainerWidth();
    const showOUMarkets = isFootball && contentWidth > 625;

    const marketSet = {
        1: false,
        X: false,
        2: false,
    };

    if (GAMES_WITH_1X2.includes(ev.sportId)) {
        marketSet['X'] = true;
        marketSet['1'] = true;
        marketSet['2'] = true;
    } else {
        marketSet['1'] = true;
        marketSet['2'] = true;
    }

    items.forEach((item) => {
        if (item?.odds > 1) {
            marketSet[item.bet] = item;
            if (item?.bet?.toLowerCase() === 'uafgjort') {
                marketSet['X'] = item;
            }
        }
    });

    const [marketOU] = (ev.marketList?.[0] &&
        ev.marketList.filter(isMarketOverUnder)) || [null];

    const buttonsRow = (marketSet, className, market) => (
        <MarketButtonsRow>
            {marketSet['2'] || (!marketSet['2'] && marketSet['X']) ? (
                <ViewMainMarketBtn
                    disabled={disabled}
                    className={className}
                    item={marketSet['1']}
                    market={market}
                    live={live}
                    ev={ev}
                />
            ) : null}
            {marketSet['X'] ? (
                <ViewMainMarketBtn
                    disabled={disabled}
                    className={className}
                    item={marketSet['X']}
                    market={market}
                    live={live}
                    ev={ev}
                />
            ) : null}
            {!marketSet['X'] && !marketSet['2'] ? (
                <ViewMainMarketBtn
                    disabled={disabled}
                    className={className}
                    item={false}
                    market={market}
                    live={live}
                    ev={ev}
                />
            ) : null}
            <ViewMainMarketBtn
                disabled={disabled}
                className={className}
                item={marketSet['2']}
                market={market}
                live={live}
                ev={ev}
            />
        </MarketButtonsRow>
    );

    if (detectMobile()) {
        return buttonsRow(marketSet, '', market);
    } else {
        return (
            <Row $gap={showOUMarkets ? '8px' : '0'}>
                <MarketButtonsCol
                    $contentWidth={contentWidth}
                    $showOUMarkets={showOUMarkets}
                >
                    {buttonsRow(marketSet, '', market)}
                </MarketButtonsCol>
                {showOUMarkets && (
                    <OUMarketButtonsCol $contentWidth={contentWidth}>
                        <ViewOUButtons ev={ev} market={marketOU} />
                    </OUMarketButtonsCol>
                )}
            </Row>
        );
    }
};

export default MainMarkets;
